// Funny — comic-book "POW!" burst with concentric mint rings, 8 zigzag spokes,
// and damped wobble. Designed to read as kid-friendly slapstick without an
// actual character mesh deformation.
export const FUNNY_FRAG = /* glsl */ `
  precision mediump float;
  varying vec2 vUv;
  uniform float uTime;
  uniform float uDuration;
  uniform vec2 uAspect;
  uniform vec2 uCenter;

  void main() {
    vec2 uv = ((vUv - uCenter) * 2.0) * uAspect;
    float r = length(uv);
    float a = atan(uv.y, uv.x);

    float t = clamp(uTime / uDuration, 0.0, 1.0);
    float wobble = sin(t * 18.0) * exp(-3.5 * t);
    float ringT = t * 1.1 + 0.05 * wobble;

    float ring1 = 1.0 - smoothstep(0.0, 0.07, abs(r - ringT));
    float ring2 = 1.0 - smoothstep(0.0, 0.05, abs(r - (ringT + 0.12)));
    float ring3 = 1.0 - smoothstep(0.0, 0.04, abs(r - (ringT + 0.24)));
    float rings = ring1 + ring2 * 0.6 + ring3 * 0.35;

    // 8 cartoon spokes, only visible near the leading ring
    float spokeMask = step(0.85, abs(cos(a * 4.0)));
    float spokeBand = exp(-pow((r - ringT) * 6.0, 2.0));
    float spokes = spokeMask * spokeBand;

    float env = sin(t * 3.14159) * (1.0 + 0.25 * wobble);
    env = max(env, 0.0);

    vec3 mint = vec3(0.063, 0.957, 0.545);
    vec3 col = mint * (rings * env + spokes * 0.7);
    float alpha = clamp(rings * env + spokes * 0.7, 0.0, 1.0);
    gl_FragColor = vec4(col, alpha);
  }
`
